<template>
  <span>
    <em class="logo" v-if="showToastLogo">
      <router-link-ex :to="countryPath" class="link_txt" :domain="getDomain('homepage')">
        <img :src="imagePath(toastLogo.white, toastLogo.default)" alt="NHN Cloud" class="logo_img is_white">
        <img :src="imagePath(toastLogo.color, toastLogo.default)" alt="NHN Cloud" class="logo_img is_color">
      </router-link-ex>
    </em>
    <h1 class="logo service_logo">
      <router-link-ex :to="isDefaultSetting ? countryPath : '/'" class="link_txt" :domain="isDefaultSetting ? getDomain('homepage') : ''">
        <img :src="imagePath(logo.white, logo.default)" alt="NHN Cloud" class="logo_img is_white">
        <img :src="imagePath(logo.color, logo.default)" alt="NHN Cloud" class="logo_img is_color">
        <img :src="imagePath(logo.mobile, logo.default)" alt="NHN Cloud" class="logo_img_m" :class="envs.logo.class">
      </router-link-ex>
    </h1>
  </span>
</template>

<script>
import GnbHeaderCommon from './GnbHeaderCommon'
import envs from '../../../common/envs';

export default {
  mixins: [GnbHeaderCommon],
  data() {
    return {
      envs: envs
    }
  },
  props: {
    isDefaultSetting: {
      type: Boolean,
      default: false
    },
    showToastLogo: {
      type: Boolean,
      default: false
    },
    toastLogo: {
      type: Object,
      default: () => {
        return {
          default: true,
          white: 'logo_nhn_cloud.svg',
          color: 'logo_nhn_cloud_color.svg',
          mobile: 'logo_nhn_cloud_m.svg'
        }
      }
    },
    logo: {
      type: Object,
      default: () => {
        return {
          default: true,
          white: 'logo_nhn_cloud.svg',
          color: 'logo_nhn_cloud_color.svg',
          mobile: 'logo_nhn_cloud_m.svg'
        }
      }
    }
  }
}
</script>
